module.exports = __webpack_public_path__ + "components/MapControl/svg/Szlak pieszy zielony.svg?015d6875";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szlak pieszy zielony.svg
// module id = 2125
// module chunks = 0